module.exports = __webpack_public_path__ + "static/media/img-topics-sample04.2c5ddc8c.jpg";